import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import DeleteModalIcon from '../../../assets/delete-modal-icon.svg';
import Button from '../../Button';

function DeleteCommentModal(props) {
  const { isOpen, onClick, title, onClose, bgColorOverlay, smallTitle } = props;

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay backgroundColor={bgColorOverlay} />
      <ModalContent p={'16px'} bgColor={'#FAFAFA'} rounded={'12px'}>
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">{title}</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onClose}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody p={0}>
          <div className="flex flex-col items-center mt-6 mb-6">
            <img className="w-[52px] h-[52px]" src={DeleteModalIcon} alt="" />
            <p className="text-[1.125rem] font-[600] text-center mt-6">{smallTitle}</p>
          </div>
        </ModalBody>
        <ModalFooter w="100%" p="0">
          <Button onClick={onClose} variant="outline" className="w-full h-[42px] !text-base">
            Cancel
          </Button>
          <Button onClick={onClick} variant="red" className="w-full h-[42px] ml-2 !text-base">
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DeleteCommentModal;
